export class RestaurantCanDeliver {
    candeliver: boolean;
    message: string;

    public static Make(obj: any): RestaurantCanDeliver {
        const restaurantCanDeliver = new RestaurantCanDeliver();
        Object.assign(restaurantCanDeliver, obj);
        return restaurantCanDeliver;
    }
}
